import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown, Button, Form, Col, Row, Nav, Table } from "react-bootstrap";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchWorkForceList } from "../../../store/actions/workForcesAction";
import TableDesign from "../../common/table/TableDesign";
import DeleteWorkForcePopup from "./DeleteWorkForcePopup";
import editIcon from "../../../assets/images/mega_edit.png";
import reports from "../../../store/reducerSlice/reports";
// import dayjs from 'dayjs/locale/es'
// import ShowWorkForceUrlPopup from "./ShowWorkForceUrlPopup";
import ManageWorkForce from "./ManageWorkForce";
import { resetPopup } from "../../../store/reducerSlice/clients";
import envalope from "../../../assets/images/envalope.png";
import download from "../../../assets/images/download.png";
import black from "../../../assets/images/black.png";
import red from "../../../assets/images/red.png";
import darkYellow from "../../../assets/images/darkYellow.png";
import yellow from "../../../assets/images/yellow.png";
import download2 from "../../../assets/images/download2.png";
import greenBox from "../../../assets/images/greenBox.png";
import moment from "moment";
const tableHeadings = [
  {
    label: "S. No.",
  },

  {
    label: "Virtual Ward",
  },
  {
    label: "WORKFORCE Capacity (See table above)",
    whiteSpace: "text-wrap",
  },

  {
    label: "No. of staff on COVID related absence?",
    whiteSpace: "text-wrap",
  },
  {
    label: "No. of inreach staff (in acutes pulling into community)",
    whiteSpace: "text-wrap",
  },

  {
    label: "Issues affecting flow and actions/source of admissions yesterday",
    whiteSpace: "text-wrap",
  },
  {
    label: "Date & Time",
  },
  {
    label: "Action",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const WorkForceList = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState("all");
  const [selectWorkforce, setSelectWorkforce] = useState(null);

  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();
  const [activeTab, setActiveTab] = useState("");
  const searchInputRef = useRef(null);
  const [filterOption, setFilterOption] = useState({});
  const [deleteRec, setDeleteRec] = useState(null);
  const [workForceLink, setWorkForceLink] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [workForceLinkModalShow, setWorkForceLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;
  const {
    returnList,
    filtered,
    pagination,
    isLoader,
    isRecordUpdated,
    isRecordAdded,
  } = useSelector((state) => {
    return state.workForces;
  });
  const { reports, downloadFileOfDate } = useSelector((state) => {
    return state.reports;
  });
  const page = pagination?.currentPage;

  const cc = filtered || returnList;

  useEffect(() => {
    if (location?.state?.previousActiveTab) {
      setActiveTab(location?.state?.previousActiveTab);
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state?.previousActiveTab]);

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({ search: searchText, page: 1 });
    }
  }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      dispatch(fetchWorkForceList(filterOption));
    }
  }, [filterOption, isRecordUpdated]);

  const filterStatusHandler = (obj) => {
    let val = { ...filterOption };
    val.status = obj.status;
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const hideHandle = () => {
    setModalShow(false);
    // setSelectWorkforce(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWorkForceLinkModalShow(false);
  };
  const createUpdateWard = (ward) => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectWorkforce(ward);
    setTitle("Update Ward");
    setMessage("Ward updated successfully!");
    setShowResult(true);
  };
  const addNewWorkForce = () => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectWorkforce(null);
    setTitle("Add Workforce");
    setMessage("Workforce has been added successfully.");
    setShowResult(true);
  };
  const deleteEventHandler = (rec) => {
    setDeleteRec(rec?.workForceId);
    setDeleteModalShow(true);
  };

  const formatedDate = (val) => {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(val).toLocaleString("nl-NL", options);
  };

  const navigateTodetail = (val) => {
    navigate(`/ward-detail/${val.wardId}`);
  };

  const navigateToPreview = (val) => {
    navigate(`/preview-workForce/${val.workForceId}`, {
      state: { activeTab: activeTab },
      replace: true,
    });
  };
  //  Report Navigate
  const navigateReport = () => {
    navigate("/report");
  };
  //  Workforce Navigate
  const navigateWorkforce = () => {
    navigate("/workforce");
  };

  const navigateReportTime = () => {
    navigate("/report-time");
  };
  //  Ucrt Navigate
  const navigateUcrtModule = () => {
    navigate("/ucrt-module");
  };
  return (
    <>
      {/* Modal Download Date wise report */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise Report
          </h4>
        </Modal.Header>
        <Modal.Body className="px-5">
          <Form.Group className="mb-3">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control type="date" placeholder="select" autoFocus />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          <a
            className="downloadBtn rounded"
            href={downloadFileOfDate}
            target="_blank"
          >
            <img src={download} /> Download Report
          </a>
          <span className="cancel-btn mt-4" onClick={handleClose}>
            Cancel
          </span>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* End Model */}
      <div className="container">
        <ManageWorkForce
          show={modalShow}
          onHide={hideHandle}
          title={selectWorkforce ? "Edit WorkForce" : "Add WorkForce"}
          selectWorkforce={selectWorkforce}
          setModalShow={setModalShow}
        />
        <DeleteWorkForcePopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        {/* <ShowWorkForceUrlPopup
          onHide={hideHandle}
          workForceLink={workForceLink}
          workForceLinkModalShow={workForceLinkModalShow}
          setWorkForceLinkModalShow={setWorkForceLinkModalShow}
        /> */}

        <h1 className="main-title">Reports</h1>

        <div className="block-section">
          <Button
            variant="outline-primary"
            className="outline-primary me-4 reportBtn"
            onClick={navigateReport}
          >
            Manage Reports
          </Button>
          <Button
            variant="outline-primary btn-primary reportBtn me-4"
            onClick={navigateWorkforce}
          >
            Workforce Capacity
          </Button>
          {/* <Button
            variant="outline-primary reportBtn"
            onClick={navigateUcrtModule}
          >
            UCRT
          </Button> */}
          {/* {adminDetail?.isAdmin && <Button
                      variant="outline-primary reportBtn"
                      onClick={navigateReportTime}
                    >
                      Set Report Time
                    </Button>} */}
        </div>

        <div className="para-range1" style={{ display: "flex" }}>
          Workforce Capacity:
          <div className="ms-4">
            <Table striped bordered hover>
              <tbody style={{ textAlign: "center" }}>
                <tr>
                  {/* <td rowSpan={2} style={{alignItems:'center', textAlign:'center'}}>Workforce Capacity</td> */}
                  <td style={{ padding: "2px 16px" }}>Below 40%</td>
                  <td style={{ padding: "2px 16px" }}>40% to 65%</td>
                  <td style={{ padding: "2px 16px" }}>65% to 80%</td>
                  <td style={{ padding: "2px 16px" }}>80% and above</td>
                </tr>
                <tr>
                  <td style={{ padding: "2px 16px" }}>4</td>
                  <td style={{ padding: "2px 16px" }}>3</td>
                  <td style={{ padding: "2px 16px" }}>2</td>
                  <td style={{ padding: "2px 16px" }}>1</td>
                </tr>
              </tbody>
            </Table>
            {/* <span className="px-2 w-100 justify-between">
              
              Below 1 <span style={{ marginLeft: "10px" }}>1</span>
            </span>
            <br />
            <span className="px-2 w-100 justify-between">
              2 to 3{" "}
              <span style={{ marginLeft: "10px" }}>2</span>
            </span>
            <br />
            <span className="px-2 w-100 justify-between">
              3 to 4{" "}
              <span style={{ marginLeft: "10px" }}>3</span>
            </span>
            <br />
            <span className="px-2 w-100 justify-between">
             4 and above{" "}
              <span style={{ marginLeft: "10px" }}>4</span>
            </span> */}
          </div>
        </div>

        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of workforce capacity",
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td>

                    <td align="center">
                      {row.ward?.isActive ? (
                        <>{row.ward?.name}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.ward?.name}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.ward?.isActive ? (
                        <>{row.workforceCapacity}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.workforceCapacity}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.ward?.isActive ? (
                        <>{row.numberOfStaffOnCovidRelatedAbsence}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.numberOfStaffOnCovidRelatedAbsence}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.ward?.isActive ? (
                        <>{row.numberOfEnrichedStaff}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.numberOfEnrichedStaff}
                        </span>
                      )}
                    </td>

                    <td align="left">
                      {row.ward?.isActive ? (
                        <>{row.issueAffecting}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.issueAffecting}
                        </span>
                      )}
                    </td>
                    <td style={{ width: "120px" }}>
                      {row.ward?.isActive ? (
                        <>{formatedDate(row.updatedAt)}</>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {formatedDate(row.updatedAt)}
                        </span>
                      )}
                    </td>
                    <td align="left">
                      {row.isClientLocation && row.isClientWardType ? (
                        <>
                          {row.ward?.isActive ? (
                            <>
                              <img
                                src={editIcon}
                                style={{
                                  height: "16px",
                                  width: "16px",
                                  cursor: "pointer",
                                }}
                                alt="edit"
                                onClick={() => createUpdateWard(row)}
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : null}
                    </td>
                  </tr>
                );
            })
          ) : (
            <tr>
              <td colSpan="8">No Result Found</td>
            </tr>
          )}
        </TableDesign>
      </div>
    </>
  );
};

export default WorkForceList;
